export default {
  brandName: "Basetao Sheet",
  navHome: "Home",
  navGuide: "Spreadsheet Guide",
  navCategories: "Categories",
  navFaq: "FAQ",
  navShoppingGuide: "Shopping Guide",
  articleNotFound: "Article not found",
  tocTitle: "Table of Contents",
  backHome: "Back to Home",
  relatedTitle: "Related Resources",
  authorName: "Basetao Sheet Editorial Team",
  authorRole: "Independent Shopping Research",
  articleFaqTitle: "Frequently Asked Questions",
  ctaBasetao: "Basetao Spreadsheet",
  ctaBuyNow: "Buy It Now",
  languageLabel: "Language",
  footerTagline:
    "An independent resource hub for Basetao Spreadsheet research, product categories, guides and practical Chinese shopping tips.",
  footerNavTitle: "Explore",
  footerCategoriesTitle: "Categories",
  footerLegalTitle: "Legal",
  footerPrivacy: "Privacy",
  footerTerms: "Terms",
  footerDisclaimer: "Disclaimer",
  footerAbout: "About",
  footerContact: "Contact",
  footerDisclaimerText:
    "This is an independent informational website. We are not affiliated with, endorsed by, or the official site of Basetao. All trademarks belong to their respective owners. Product availability, prices and shipping rates may change at any time.",
  footerCopyright: "All rights reserved.",
  footerMadeWith: "Independent resource · Updated regularly",
};